<template>
  <div>
    <b-modal
      hide-footer
      id="modalVerParticipantes"
      title="Participantes Convidados"
      centered
    >
      <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895FF"
      />

      <!-- Técnicos -->
      <ul class="list-group list-group-flush" v-if="participantes && participantes.length">
        <li class="list-group-item">
          <strong>Técnicos</strong>
        </li>
        <li
          class="list-group-item"
          v-for="participante in participantes"
          :key="participante.id"
        >
          {{ participante.nome }}
          <span class="d-block small text-muted">
            {{ participante.email_user || 'Sem e-mail informado' }}
          </span>
        </li>
      </ul>

      <!-- Outros Participantes -->
      <ul class="list-group list-group-flush" v-if="usuariosparticipantes && usuariosparticipantes.length">
        <li class="list-group-item">
          <strong>Outros Participantes</strong>
        </li>
        <li
          class="list-group-item"
          v-for="(participante, index) in usuariosparticipantes"
          :key="index"
        >
          {{ participante.value }}
        </li>
      </ul>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalVerParticipantes",
  props: {
    participantes: Array,
    usuariosparticipantes: Array,
    loading: Boolean,
  },
};
</script>
